import AFRAME from 'aframe'
import fs from '../glsl/sharpen.frag'
import vs from '../glsl/base.vert'
let THREE = require('three')

AFRAME.registerComponent('sharpen', {
  schema: {
    active: {
      default: true,
    },
    strength: {
      default: 3.6,
    },
    center: {
      type: 'vec2',
      default: { x: 0.5, y: 0.5 },
    },
  },

  init: function() {
    this.system = this.el.sceneEl.systems.effects
    this.material = new THREE.ShaderMaterial({
      fragmentShader: fs,
      vertexShader: vs,
      uniforms: {
        tDiffuse: this.system.tDiffuse,
        center: {
          type: 'v2',
          value: new THREE.Vector2(),
        },
        strength: {
          type: 'f',
          value: this.data.strength,
        },
        resolution: {
          type: 'v2',
          value: new THREE.Vector2(),
        },
        time: {
          type: 'f',
          value: 0,
        },
      },
    })
    this.system.register(this)
    this.needsResize = true

    // For easier gsap animation
    // Object.defineProperty(this, 'strength', {
    //   get: function() {
    //     return this.material.uniforms.strength.value
    //   },
    //   set: function(val) {
    //     this.material.uniforms.strength.value = val
    //   },
    // })
  },

  update: function() {
    this.bypass = !this.data
    this.material.uniforms.center.value.set(this.data.center.x, this.data.center.y)
    if (this.data.active){
      this.material.uniforms.strength.value = this.data.strength
    }else{
      this.material.uniforms.strength.value = 0
    }




  },
  tick: function() {
    //if (!this.data.active) return
    //this.material.uniforms['time'].value += 0.01
  },
  setSize: function(w, h) {
    // prettier-ignore
    this.material.uniforms.resolution.value.set(
      w,
      h,
    )
  },

  resize: true,

  remove: function() {
    this.material.dispose()
    this.system.unregister(this)
  },
})
